import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Confirmation for the two actions a customer can't undo by clicking again:
// deactivating someone (they lose access immediately) and removing them.
//
// data.title/data.message/data.confirmLabel come from the caller already
// translated (see employees.component.ts, catering.component.ts) — this
// component has no fixed copy of its own except Cancel and the default
// "Confirm" fallback.
@Component({
  selector: 'portal-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="confirm-message">{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="ref.close(false)">{{ 'confirm.cancel' | translate }}</button>
      <button mat-flat-button color="warn" (click)="ref.close(true)">{{ data.confirmLabel || ('confirm.confirm' | translate) }}</button>
    </mat-dialog-actions>
  `,
  styles: [`.confirm-message { font-size: 14px; color: #46617a; line-height: 1.5; margin: 0; }`]
})
export class ConfirmDialogComponent {
  constructor(
    public ref: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
}
